import { createSelector } from "reselect";
import SelectionState from "state/selections/SelectionState";
import scope from "./scope";
import { memoize, uniqueByKey } from "@ls/js-utils";

export const selectDefinitions = memoize((selectionState) => {
  if (selectionState === SelectionState.UNCOMMITTED) {
    return (state) => state[scope]["definitions"][selectionState];
  }

  return createSelector(
    (state) => state[scope]["definitions"][selectionState],
    (definitions) => {
      const completeDefinitions = definitions.filter(
        ({ complete }) => complete
      );
      return completeDefinitions.filter(
        uniqueByKey(completeDefinitions, "key")
      );
    }
  );
});
